<template>
    <div>
        <div :id="getId"
            style="height: 100%; width: 100%; z-index:1; min-height:250px">
            <div ref="slot">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import {
    	debounce
    }
    from 'voUtils/tools.js';

    export default {
    	voVueComponent: 'voffice-openstreetmap',
    	props: {
    		items: {
    			type: Array,
    			default: function() {
    				return [];
    			}
    		},
    		markerPos: {
    			type: Array,
    			default: function() {
    				return [];
    			}
    		},
    		mapId: {
    			type: String,
    			default: 'map'
    		},
    		highlight: Number,
    		initialPos: {
    			type: Array,
    			default: function() {
    				return [13.570707237974283, 54.42541049736595];
    			}
    		},
    		initialZoom: {
    			type: [String, Number],
    			default: 14
    		},
    		cluster: undefined,
    		selected: Object,
    		draggable: {
    			type: [String, Boolean],
    			default: true // true, false, center
    		},
    		scrollWheelZoom: {
    			type: [String, Boolean],
    			default: false // true, false, center
    		},
    		doubleClickZoom: {
    			type: [String, Boolean],
    			default: true // true, false, center
    		},
    		unitId: Number
    	},
    	created: function() {
    		var vc = this;

    		/*this.onMarkerClicked = function() {
    			vc.$emit('update:selected', this.customData);
    		};*/
    	},
    	mounted: function() {
    		this.observeVisibility();
    	},
    	methods: {

    		observeVisibility() {
    				const options = {
    					root: null,
    					rootMargin: '0px',
    					threshold: 0.1 // Einstellen Sie den Schwellenwert basierend auf Ihren Anforderungen
    				};

    				const callback = (entries, observer) => {
    					entries.forEach(entry => {
    						if (entry.isIntersecting) {
    							this.createMap();
    							observer.unobserve(entry.target);
    						}
    					});
    				};

    				const observer = new IntersectionObserver(callback, options);
    				observer.observe(document.getElementById(this.getId));
    			},

    			check4TouchScreen: function() {
    				if ('ontouchstart' in window || navigator.maxTouchPoints) {
    					//console.log('ontouchstart');
    					return false;
    				} else {
    					//console.log('Kein ontouchstart');
    					return false;
    				}

    			},
    			createMap() {

    				const tiles = window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
    				});
    				this.icon = window.L.divIcon({
    					html: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="39px" viewBox="0 0 24 38" version="1.1"><g id="surface1"><path style=" stroke:none;fill-rule:nonzero;fill:rgb(35.294119%,57.254905%,47.843137%);fill-opacity:1;" d="M 14.460938 12.019531 C 14.460938 12.753906 13.859375 13.316406 13.140625 13.316406 C 12.691406 13.316406 12.300781 13.109375 12.058594 12.785156 C 11.820312 13.109375 11.429688 13.316406 11.011719 13.316406 C 10.261719 13.316406 9.691406 12.753906 9.691406 12.019531 C 9.691406 11.3125 10.261719 10.722656 11.011719 10.722656 C 11.429688 10.722656 11.820312 10.929688 12.058594 11.253906 C 12.300781 10.929688 12.691406 10.722656 13.140625 10.722656 C 13.859375 10.722656 14.460938 11.3125 14.460938 12.019531 Z M 14.460938 12.019531 "/><path style=" stroke:none;fill-rule:evenodd;fill:rgb(35.294119%,57.254905%,47.843137%);fill-opacity:1;" d="M 20.878906 3.886719 C 23.339844 6.480469 24.328125 10.074219 23.761719 13.550781 C 23.609375 14.550781 23.21875 15.496094 22.738281 16.40625 L 11.460938 38 L 4.171875 22.535156 L 4.171875 12.871094 L 12.300781 5.039062 L 19.648438 12.84375 L 19.648438 16.144531 C 19.648438 16.527344 19.949219 16.851562 20.339844 16.851562 C 20.730469 16.851562 21.03125 16.527344 21.03125 16.144531 L 21.03125 12.578125 C 21.03125 12.402344 20.96875 12.253906 20.851562 12.105469 L 12.839844 3.59375 C 12.71875 3.445312 12.539062 3.359375 12.359375 3.359375 C 12.179688 3.328125 11.96875 3.417969 11.820312 3.5625 L 2.96875 12.078125 C 2.851562 12.226562 2.761719 12.402344 2.761719 12.578125 L 2.761719 19.558594 L 1.050781 15.9375 C 0.570312 14.90625 0.238281 13.816406 0.148438 12.695312 C -0.03125 10.25 0.570312 7.804688 2.011719 5.746094 C 3.929688 2.976562 7.078125 0.148438 11.96875 0.148438 C 16.078125 0.148438 18.929688 1.828125 20.878906 3.859375 Z M 13.019531 14.167969 C 14.308594 13.875 15.238281 13.050781 15.238281 12.046875 C 15.238281 10.929688 14.039062 9.984375 12.511719 9.839844 C 12.421875 9.632812 12.269531 9.457031 12.058594 9.457031 C 11.878906 9.457031 11.699219 9.632812 11.640625 9.839844 C 10.078125 9.984375 8.910156 10.929688 8.910156 12.046875 C 8.910156 13.050781 9.839844 13.875 11.128906 14.167969 C 11.128906 14.167969 11.128906 14.699219 11.128906 14.699219 C 11.128906 14.847656 11.25 14.964844 11.371094 14.964844 L 11.398438 14.964844 L 11.398438 22.121094 C 11.28125 22.121094 11.191406 22.210938 11.191406 22.328125 L 11.191406 22.742188 C 11.191406 22.859375 11.28125 22.976562 11.398438 22.976562 L 11.398438 24.15625 L 11.011719 24.15625 L 11.011719 23.625 L 9.449219 23.625 L 9.449219 24.539062 L 10.171875 24.539062 L 10.171875 25.039062 L 9.449219 25.039062 L 9.449219 25.980469 L 10.171875 25.980469 L 10.171875 26.480469 L 9.449219 26.480469 L 9.449219 27.367188 L 11.011719 27.367188 L 11.011719 26.863281 L 11.398438 26.863281 L 11.398438 27.835938 C 11.398438 28.101562 11.609375 28.308594 11.878906 28.308594 L 12.269531 28.308594 C 12.539062 28.308594 12.75 28.101562 12.75 27.835938 L 12.75 22.976562 C 12.871094 22.976562 12.960938 22.859375 12.960938 22.742188 L 12.960938 22.328125 C 12.960938 22.210938 12.871094 22.121094 12.75 22.121094 L 12.75 14.964844 L 12.78125 14.964844 C 12.898438 14.964844 13.019531 14.847656 13.019531 14.699219 C 13.019531 14.699219 13.019531 14.167969 13.019531 14.167969 Z M 13.019531 14.167969 "/></g></svg>`,
    					className: "openstreet-marker",
    					iconSize: [24, 38],
    					iconAnchor: [12, 38],
    					popupAnchor: [0, -15]
    				})
    				const map = window.L.map(this.getId, {
    					center: new window.L.LatLng(this.composeGeolocation(this.initialPos[1]), this.composeGeolocation(this.initialPos[0]), {
    						icon: this.icon
    					}),
    					fullscreenControl: true,
    					zoom: this.initialZoom,
    					dragging: true,
    					doubleClickZoom: this.doubleClickZoom,
    					scrollWheelZoom: this.check4TouchScreen(),
    					attributionControl: true,
    					layers: [tiles]
    				});
    				map.on('popupopen', function(e) {
    					$('.leaflet-popup-close-button').removeAttr('href');
    					var px = map.project(e.target._popup._latlng);
    					px.y -= e.target._popup._container.clientHeight / 2 + 100;
    					map.panTo(map.unproject(px), {
    						animate: false
    					});
    				});
    				this.markers = [];
    				this.map = map;
    				if (this.markerPos && this.markerPos.length > 0) {
    					//console.log('this.markerPos', this.markerPos);
    					this.updateSingleMarker();
    				} else if (this.cluster) {
    					this.updateMarkers();
    				}
    			},
    			updateSingleMarker() {
    				if (this.map) {
    					this.deleteMarkers();

    					const marker = new window.L.marker(new window.L.LatLng(this.composeGeolocation(this.markerPos[1]), this.composeGeolocation(this.markerPos[0])), {
    						icon: this.icon
    					});
    					marker.addTo(this.map);
    					this.map.panTo(new window.L.LatLng(this.composeGeolocation(this.markerPos[1]), this.composeGeolocation(this.markerPos[0])));
    				}

    			},
    			deleteMarkers() {
    				if (this.markers) {
    					this.map.removeLayer(this.markers);
    				}
    				if (this.clusterObject) {
    					this.map.removeLayer(this.clusterObject);
    				}
    				this.markers = [];
    			},
    			updateMarkers() {
    				if (this.map) {
    					this.deleteMarkers();
    					var clusters = window.L.markerClusterGroup({
    						animate: false,
    						showCoverageOnHover: false,
    					});
    					var markers = [];


    					if (this.items.length > 0) {
    						for (var i = 0; i < this.items.length; i++) {
    							var unit = this.items[i];

    							if (!unit) {
    								continue;
    							}

    							let marker;
    							if (unit.loc) {
    								marker = new window.L.marker(new window.L.LatLng(this.composeGeolocation(unit.loc.coordinates[1]), this.composeGeolocation(unit.loc.coordinates[0])), {
    									icon: this.icon,
    									customData: {
    										info: unit
    									}
    								}).setBouncingOptions({
    									bounceHeight: 30,
    									bounceSpeed: 54,
    									exclusive: true,
    								}).on('click', () => {
    									this.$emit('update:selected', marker.options.customData.info);
    								}).bindPopup(this.$refs.slot, {
    									minWidth: 270,
    									autopan: true
    								});

    								if (i === 0) {
    									this.map.flyTo(marker.getLatLng());
    								}
    								if (this.cluster) {
    									clusters.addLayer(marker);
    								} else {
    									marker.addTo(this.map)
    								}
    								this.markers.push(marker);
    								marker.getPopup().on(('remove'), () => {
    									this.$emit('update:selected', {});
    								});
    							} else if (Array.isArray(unit)) {
    								for (let i = 2; i < unit.length; i++) {
    									marker = new window.L.marker(new window.L.LatLng(this.composeGeolocation(unit[1]), this.composeGeolocation(unit[0])), {
    										icon: this.icon,
    										customData: {
    											_id: unit[i],
    											lazy: true,
    											info: unit
    										}
    									}).setBouncingOptions({
    										bounceHeight: 30,
    										bounceSpeed: 54,
    										exclusive: true,
    									}).on('click', () => {
    										this.$emit('update:selected', marker.options.customData);
    									}).bindPopup(this.$refs.slot, {
    										minWidth: 270,
    										autopan: true
    									});
    									marker.getPopup().on(('remove'), () => {
    										this.$emit('update:selected', {});
    									});
    									this.markers.push(marker);
    									clusters.addLayer(marker);
    								}
    							}
    						}
    					}


    					if (this.cluster) {
    						this.clusterObject = clusters;
    						this.map.addLayer(clusters)
    					}
    					this.map.invalidateSize(true);
    				}
    			},
    			composeGeolocation(input) {
    				return input.toFixed(6) + Math.floor(Math.random() * 4);
    			},
    			unHighlightMarker(m) {
    				if (this.highlightedMarker) {
    					if (this.highlightedMarker._icon) {
    						this.highlightedMarker._icon.classList.remove("animate-marker");
    					}
    					this.highlightedMarker = undefined;
    				}
    			},
    			highlightMarker: function(m) {
    				this.highlightedMarker = m;
    				this.map.once('moveend zoomend', () => {
    					const parent = this.clusterObject.getVisibleParent(m);
    					if (parent && parent.spiderfy) {
    						parent.spiderfy();
    					}
    					if ((this.highlightedMarker === m || !this.highlightedMarker) && m._icon) {
    						m._icon.classList.add("animate-marker");
    						m.bounce(2);
    					}
    					if (!this.highlightedMarker === m) {
    						this.unHighlightMarker(this.highlightedMarker);
    					}
    				});
    			},

    			findMarkerById(id) {
    				if (this.markers) {
    					for (let m of this.markers) {
    						if (m.options && m.options.customData && ((m.options.customData.info && m.options.customData.info._id == id) || (m.options.customData._id == id))) {
    							return m;
    						}
    					}
    				}
    			}
    	},
    	watch: {
    		items: {
    			deep: true,
    			handler: function(nv) {
    				this.updateMarkers();
    			}
    		},
    		highlight: function(id) {
    			this.unHighlightMarker(this.highlightedMarker);

    			if (id) {
    				let m = this.findMarkerById(id);

    				if (m) {
    					if (!m.getPopup().isOpen()) {
    						this.map.closePopup();
    					}
    					this.map.flyTo(m.getLatLng(), Math.max(this.map.getZoom(), 13), {
    						animate: true,
    						duration: 0.4
    					});
    					this.highlightMarker(m);

    				}
    			}
    		},
    		markerPos: {
    			deep: true,
    			handler: function(val, oldVal) {
    				this.updateSingleMarker();
    			}
    		},
    		selected: function(nv) {
    			this.unHighlightMarker(this.highlightedMarker);
    			if (nv._id) {
    				var m = this.findMarkerById(nv._id);
    				if (m) {
    					m.openPopup();
    				} else {
    					this.map.closePopup();
    				}
    			} else {
    				this.map.closePopup();
    			}
    		}

    	},
    	computed: {
    		getId: function() {
    			if (this.unitId) {
    				return this.mapId + this.unitId;
    			}
    			return this.mapId;
    		}
    	}
    };
</script>